import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketOverviewCard = ({ icon, title, value, change, changeType, description }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={icon} size={24} color="var(--color-primary)" />
        </div>
        <div className={`flex items-center gap-1 ${getChangeColor()}`}>
          <Icon name={getChangeIcon()} size={16} />
          <span className="text-sm font-medium">{change}</span>
        </div>
      </div>
      <h3 className="text-sm md:text-base text-muted-foreground mb-2">{title}</h3>
      <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">{value}</p>
      <p className="text-xs md:text-sm text-muted-foreground">{description}</p>
    </div>
  );
};

export default MarketOverviewCard;